import { render, staticRenderFns } from "./PageMainTop.vue?vue&type=template&id=8d9d315e&"
import script from "./PageMainTop.vue?vue&type=script&lang=js&"
export * from "./PageMainTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports